import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === 'undefined') return

    const ua = navigator.userAgent || navigator.vendor
    const isMobileUA = /Android|iPhone|iPad|iPod|Mobile/i.test(ua)

    setIsMobile(isMobileUA)
  }, [])

  return isMobile
}
